//  Name: price
export default {
  props: [
    'data'
  ]
}



// WEBPACK FOOTER //
// ./src/components/price/script.js